import type { ProductNoEdibleInfo } from "@dransay/api";
import type { ProductVendorListItem } from "@dransay/api/models";
import { useEffect } from "react";
import { useVendorSelection } from "~/contexts/vendor-selection.context";
import { captureEvent } from "~/tooling/telemetry/capture-event";
import { productViewedEvent } from "~/tooling/telemetry/events";
import { getDefaultVendorId } from "~/utils/vendor";
import { useCurrency } from "./use-currency-price.hook";

export const useProductViewedEvent = ({
	product,
	vendors,
}: {
	product: ProductNoEdibleInfo;
	vendors: ProductVendorListItem[];
}) => {
	const { selectedVendorId } = useVendorSelection();
	const currency = useCurrency();

	// biome-ignore lint/correctness/useExhaustiveDependencies:
	useEffect(() => {
		const vendorId = getDefaultVendorId(vendors, selectedVendorId);
		const vendor = vendors.find((v) => v.id.toString() === vendorId) ?? null;
		const event = productViewedEvent(product, vendor, currency);

		// defer the event to ensure it runs after the page view events
		requestAnimationFrame(() => {
			captureEvent(event);
		});
	}, [product?.id]);
};
